export default {
  tenantId: -1,
  schemaId: -1,
  weChatId: -1,
  memberFormId: -1,
  cookie: {
    domain: document.domain === "localhost" ? "localhost" : ".lenovonetapp.com",
  },
  api: {
    gateway: {
      general: "https://api.lenovonetapp.com",
      // general: "https://api.smarket.net.cn",
      project: "",
      JsonUrl: "https://static.lenovonetapp.com",
      // JsonUrl: "https://static.smarket.net.cn",
    },
    ungateway: {
      contentUrl: "https://s2-content.smarket.net.cn/index.php",
    },
  },
  weChatOauthUrl: "https://f.smarket.net.cn/memberb/public/wx_interface/auth",
  warningLog: {
    accessToken: "",
    title: "测试页面报警",
    ignoreList: {
      "/member/login": "401", // 第三方用户登录 未绑定
      "/article/getCollectionList": "268451864", // 文章收藏列表为空
    },
  },
  isStatic: true,
  isSK: true,
};
